// Cabin Crew Training - Mülakat Hazırlık İçerikleri (BÖLÜM 3)
// Ünite 21-26 = 6 Ünite x 5 Ders = 30 Ders

export const INTERVIEW_CONTENTS = {
  // ==================== BÖLÜM 3: MÜLAKAT HAZIRLIK ====================
  
  // ÜNİTE 21: Kendini Tanıt
  '21-1': {
    type: 'flashcard',
    title: 'Tell me about yourself',
    cards: [
      { front: 'Tell me about yourself', back: 'Bize kendinizden bahsedin' },
      { front: 'I am from Turkey', back: 'Türkiye\'denim' },
      { front: 'I am 24 years old', back: '24 yaşındayım' },
      { front: 'I graduated from university', back: 'Üniversiteden mezun oldum' },
      { front: 'I studied tourism', back: 'Turizm okudum' },
      { front: 'I have experience in customer service', back: 'Müşteri hizmetlerinde deneyimim var' },
      { front: 'I am passionate about aviation', back: 'Havacılığa tutkuluyum' },
      { front: 'I enjoy meeting new people', back: 'Yeni insanlarla tanışmayı seviyorum' },
      { front: 'I am a team player', back: 'Takım oyuncusuyum' },
      { front: 'I speak English and Turkish fluently', back: 'İngilizce ve Türkçe\'yi akıcı konuşurum' },
    ]
  },
  '21-2': {
    type: 'flashcard',
    title: 'Güçlü Yönlerin',
    cards: [
      { front: 'What are your strengths?', back: 'Güçlü yönleriniz neler?' },
      { front: 'I am a good communicator', back: 'İyi bir iletişimciyim' },
      { front: 'I work well under pressure', back: 'Baskı altında iyi çalışırım' },
      { front: 'I am adaptable', back: 'Uyum sağlayıcıyım' },
      { front: 'I am patient', back: 'Sabırlıyım' },
      { front: 'I have strong problem-solving skills', back: 'Güçlü problem çözme becerilerim var' },
      { front: 'I am reliable', back: 'Güvenilir biriyim' },
      { front: 'I pay attention to details', back: 'Ayrıntılara dikkat ederim' },
      { front: 'I stay calm in emergencies', back: 'Acil durumlarda sakin kalırım' },
    ]
  },
  '21-3': {
    type: 'flashcard',
    title: 'Zayıf Yönlerin',
    cards: [
      { front: 'What are your weaknesses?', back: 'Zayıf yönleriniz neler?' },
      { front: 'I can be a perfectionist', back: 'Mükemmeliyetci olabilirim' },
      { front: 'I am working on improving my...', back: '...geliştirmek için çalışıyorum' },
      { front: 'Sometimes I work too hard', back: 'Bazen çok fazla çalışıyorum' },
      { front: 'I am learning to delegate', back: 'Yetki devretmeyi öğreniyorum' },
      { front: 'I used to be shy', back: 'Eskiden utangaçtım' },
      { front: 'But I have overcome this', back: 'Ama bunu aştım' },
      { front: 'I am always looking to improve', back: 'Her zaman gelişmeye bakıyorum' },
    ]
  },
  '21-4': {
    type: 'voice',
    title: 'Tanıtım Pratiği',
    phrases: [
      { text: 'Hello, my name is Ayse. I am from Istanbul, Turkey.', translation: 'Merhaba, adım Ayşe. Türkiye, İstanbul\'danlıyım.' },
      { text: 'I am 25 years old and I graduated from Anadolu University.', translation: '25 yaşındayım ve Anadolu Üniversitesi\'nden mezun oldum.' },
      { text: 'I have 3 years of experience in hospitality.', translation: 'Konaklama sektöründe 3 yıllık deneyimim var.' },
      { text: 'I speak Turkish, English, and basic German.', translation: 'Türkçe, İngilizce ve temel Almanca konuşuyorum.' },
      { text: 'My dream is to become a cabin crew member.', translation: 'Hayalim kabin memuru olmak.' },
      { text: 'I am passionate about providing excellent customer service.', translation: 'Mükemmel müşteri hizmeti sunmaya tutkuluyum.' },
    ]
  },
  '21-5': {
    type: 'roleplay',
    title: 'Tanıtım Simülasyonu',
    dialogue: [
      { speaker: 'Interviewer', text: 'Good morning. Please have a seat. Tell me about yourself.', translation: 'Günaydın. Lütfen oturun. Bize kendinizden bahsedin.' },
      { speaker: 'Candidate', text: 'Good morning. Thank you. My name is... and I am from...', translation: 'Günaydın. Teşekkürler. Adım... ve ...\'danım.' },
      { speaker: 'Interviewer', text: 'What are your main strengths?', translation: 'Ana güçlü yönleriniz neler?' },
      { speaker: 'Candidate', text: 'I believe my main strengths are communication and adaptability.', translation: 'Ana güçlü yönlerimin iletişim ve uyum sağlama olduğuna inanıyorum.' },
      { speaker: 'Interviewer', text: 'And what would you say is an area for improvement?', translation: 'Peki geliştirilmesi gereken bir alan ne olur dersiniz?' },
      { speaker: 'Candidate', text: 'I tend to be a perfectionist, which sometimes means I spend too much time on details.', translation: 'Mükemmeliyetci olma eğilimdeyim, bu bazen ayrıntılara çok zaman harcadığım anlamına gelir.' },
    ]
  },

  // ÜNİTE 22: Sık Sorulan Sorular
  '22-1': {
    type: 'flashcard',
    title: 'Why cabin crew?',
    cards: [
      { front: 'Why do you want to be a cabin crew member?', back: 'Neden kabin memuru olmak istiyorsunuz?' },
      { front: 'I love traveling and meeting new people', back: 'Seyahat etmeyi ve yeni insanlarla tanışmayı seviyorum' },
      { front: 'I enjoy providing excellent customer service', back: 'Mükemmel müşteri hizmeti sunmaktan keyif alıyorum' },
      { front: 'I am passionate about aviation', back: 'Havacılığa tutkuluyum' },
      { front: 'I want to be part of a dynamic team', back: 'Dinamik bir ekibin parçası olmak istiyorum' },
      { front: 'It has been my dream since childhood', back: 'Çocukluğumdan beri hayalimdi' },
      { front: 'I thrive in a fast-paced environment', back: 'Hızlı tempolu ortamlarda başarılı oluyorum' },
      { front: 'I want to experience different cultures', back: 'Farklı kültürleri deneyimlemek istiyorum' },
    ]
  },
  '22-2': {
    type: 'flashcard',
    title: 'Why this airline?',
    cards: [
      { front: 'Why do you want to work for our airline?', back: 'Neden havayolumuz için çalışmak istiyorsunuz?' },
      { front: 'Your airline has an excellent reputation', back: 'Havayolunuzun mükemmel bir ünü var' },
      { front: 'I admire your company values', back: 'Şirket değerlerinize hayranım' },
      { front: 'You are a leader in the industry', back: 'Sektörün liderisiniz' },
      { front: 'I am impressed by your customer service', back: 'Müşteri hizmetlerinizden etkilendim' },
      { front: 'Your training program is world-class', back: 'Eğitim programınız dünya sınıfında' },
      { front: 'I want to grow with your company', back: 'Şirketinizle büyümek istiyorum' },
      { front: 'Turkish Airlines flies to many destinations', back: 'THY birçok destinasyona uçuyor' },
    ]
  },
  '22-3': {
    type: 'flashcard',
    title: 'Where do you see yourself?',
    cards: [
      { front: 'Where do you see yourself in 5 years?', back: 'Kendinizi 5 yıl sonra nerede görüyorsunuz?' },
      { front: 'I see myself as a senior cabin crew member', back: 'Kendimi kıdemli kabin memuru olarak görüyorum' },
      { front: 'I hope to become a purser', back: 'Şef kabin memuru olmayı umuyorum' },
      { front: 'I want to continue growing in this industry', back: 'Bu sektörde büyümeye devam etmek istiyorum' },
      { front: 'I may consider training new crew members', back: 'Yeni ekip üyelerini eğitmeyi düşünebilirim' },
      { front: 'I am committed to long-term career development', back: 'Uzun vadeli kariyer gelişimi için kararlıyım' },
    ]
  },
  '22-4': {
    type: 'voice',
    title: 'Cevap Pratiği',
    phrases: [
      { text: 'I want to be a cabin crew member because I love traveling and helping people.', translation: 'Kabin memuru olmak istiyorum çünkü seyahat etmeyi ve insanlara yardım etmeyi seviyorum.' },
      { text: 'Your airline is known for its excellent service and I want to be part of that.', translation: 'Havayolunuz mükemmel hizmetiyle bilinir ve bunun bir parçası olmak istiyorum.' },
      { text: 'In 5 years, I see myself as a senior crew member mentoring new joiners.', translation: '5 yıl içinde kendimi yeni katılanlara mentorlarık yapan kıdemli bir ekip üyesi olarak görüyorum.' },
    ]
  },
  '22-5': {
    type: 'roleplay',
    title: 'SSS Simülasyonu',
    dialogue: [
      { speaker: 'Interviewer', text: 'Why do you want to be a cabin crew member?', translation: 'Neden kabin memuru olmak istiyorsunuz?' },
      { speaker: 'Candidate', text: 'I am passionate about aviation and customer service. I want to create memorable experiences for passengers.', translation: 'Havacılık ve müşteri hizmetlerine tutkuluyum. Yolcular için unutulmaz deneyimler yaratmak istiyorum.' },
      { speaker: 'Interviewer', text: 'Why specifically our airline?', translation: 'Özellikle neden bizim havayolumuz?' },
      { speaker: 'Candidate', text: 'I admire your reputation for hospitality and your extensive route network.', translation: 'Misafirperverlik konusundaki itibarınıza ve geniş rota ağınıza hayranım.' },
    ]
  },

  // ÜNİTE 23: Senaryo Soruları
  '23-1': {
    type: 'flashcard',
    title: 'Zor Yolcu Senaryosu',
    cards: [
      { front: 'How would you handle an angry passenger?', back: 'Kızgın bir yolcuyla nasıl başa çıkarsınız?' },
      { front: 'First, I would listen to their concerns', back: 'Önce endişelerini dinlerdim' },
      { front: 'I would remain calm and professional', back: 'Sakin ve profesyonel kalırdım' },
      { front: 'I would apologize for the inconvenience', back: 'Rahatsızlık için özür dilerdim' },
      { front: 'I would try to find a solution', back: 'Çözüm bulmaya çalışırdım' },
      { front: 'If needed, I would involve my supervisor', back: 'Gerekirse amirimi dahil ederdim' },
      { front: 'I would follow up to ensure satisfaction', back: 'Memnuniyeti sağlamak için takip ederdim' },
    ]
  },
  '23-2': {
    type: 'flashcard',
    title: 'Acil Durum Senaryosu',
    cards: [
      { front: 'What would you do in an emergency?', back: 'Acil durumda ne yaparsınız?' },
      { front: 'I would follow safety procedures', back: 'Güvenlik prosedürlerini takip ederdim' },
      { front: 'I would stay calm and reassure passengers', back: 'Sakin kalır ve yolcuları sakinleştirirdim' },
      { front: 'I would give clear instructions', back: 'Net talimatlar verirdim' },
      { front: 'Safety is always the priority', back: 'Güvenlik her zaman önceliktir' },
      { front: 'I would coordinate with other crew members', back: 'Diğer ekip üyeleriyle koordine olurdum' },
    ]
  },
  '23-3': {
    type: 'flashcard',
    title: 'Ekip Çatışması Senaryosu',
    cards: [
      { front: 'How would you handle conflict with a colleague?', back: 'Bir meslektaşla yaşanan çatışmayı nasıl çözersiniz?' },
      { front: 'I would discuss the issue privately', back: 'Sorunu özel olarak tartışırdım' },
      { front: 'I would try to understand their perspective', back: 'Bakış açılarını anlamaya çalışırdım' },
      { front: 'I would focus on finding a solution', back: 'Çözüm bulmaya odaklanırdım' },
      { front: 'I would maintain professionalism', back: 'Profesyonelliği korurdum' },
      { front: 'Teamwork is essential in aviation', back: 'Havacılıkta takım çalışması çok önemli' },
    ]
  },
  '23-4': {
    type: 'flashcard',
    title: 'STAR Metodu',
    cards: [
      { front: 'S - Situation', back: 'Durum' },
      { front: 'T - Task', back: 'Görev' },
      { front: 'A - Action', back: 'Aksiyon' },
      { front: 'R - Result', back: 'Sonuç' },
      { front: 'Describe a specific situation', back: 'Belirli bir durumu tanımlayın' },
      { front: 'Explain your role/task', back: 'Rolünüzü/görevinizi açıklayın' },
      { front: 'Describe the actions you took', back: 'Yaptığınız eylemleri tanımlayın' },
      { front: 'Share the positive results', back: 'Olumlu sonuçları paylaşın' },
    ]
  },
  '23-5': {
    type: 'roleplay',
    title: 'Senaryo Simülasyonu',
    dialogue: [
      { speaker: 'Interviewer', text: 'A passenger is very angry about a delayed flight. What do you do?', translation: 'Bir yolcu geciken uçuş nedeniyle çok kızgın. Ne yaparsınız?' },
      { speaker: 'Candidate', text: 'First, I would approach them calmly and listen to their concerns without interrupting.', translation: 'Önce onlara sakinçe yaklaşır ve endişelerini sözünü kesmeden dinlerdim.' },
      { speaker: 'Interviewer', text: 'They continue shouting. What next?', translation: 'Bağırmaya devam ediyorlar. Sonra ne?' },
      { speaker: 'Candidate', text: 'I would empathize, apologize for the inconvenience, and offer solutions like rebooking or refreshments.', translation: 'Empati kurar, rahatsızlık için özür diler ve yeniden rezervasyon veya ikram gibi çözümler sunardım.' },
    ]
  },

  // ÜNİTE 24: Assessment Day
  '24-1': {
    type: 'flashcard',
    title: 'Grup Tartışması',
    cards: [
      { front: 'Group discussion', back: 'Grup tartışması' },
      { front: 'Listen to others', back: 'Başkalarını dinle' },
      { front: 'Contribute your ideas', back: 'Fikirlerini katkı olarak sun' },
      { front: 'Be respectful of different opinions', back: 'Farklı görüşlere saygılı ol' },
      { front: 'Don\'t dominate the conversation', back: 'Konuşmayı domine etme' },
      { front: 'Include quieter members', back: 'Sessiz üyeleri dahil et' },
      { front: 'Stay on topic', back: 'Konuya sadık kal' },
      { front: 'Summarize key points', back: 'Anahtar noktaları özetle' },
    ]
  },
  '24-2': {
    type: 'flashcard',
    title: 'Takım Çalışması',
    cards: [
      { front: 'Team exercise', back: 'Takım egzersizi' },
      { front: 'Cooperate with others', back: 'Başkalarıyla işbirliği yap' },
      { front: 'Take initiative', back: 'Inisiyatif al' },
      { front: 'Support team members', back: 'Takım üyelerini destekle' },
      { front: 'Share responsibilities', back: 'Sorumlulukları paylaş' },
      { front: 'Celebrate team success', back: 'Takım başarısını kutla' },
      { front: 'Be flexible', back: 'Esnek ol' },
    ]
  },
  '24-3': {
    type: 'flashcard',
    title: 'Sunum Yapma',
    cards: [
      { front: 'Presentation skills', back: 'Sunum becerileri' },
      { front: 'Speak clearly', back: 'Net konuş' },
      { front: 'Make eye contact', back: 'Göz teması kur' },
      { front: 'Use confident body language', back: 'Güvenli beden dili kullan' },
      { front: 'Keep it concise', back: 'Kısa ve öz tut' },
      { front: 'Engage your audience', back: 'Dinleyicilerin ilgisini çek' },
      { front: 'Practice beforehand', back: 'Önceden pratik yap' },
    ]
  },
  '24-4': {
    type: 'voice',
    title: 'İngilizce İletişim',
    phrases: [
      { text: 'I think we should consider all options before deciding.', translation: 'Karar vermeden önce tüm seçenekleri düşünmeliyiz diye düşünüyorum.' },
      { text: 'That\'s a great point. Building on that idea...', translation: 'Bu harika bir nokta. Bu fikrin üzerine ekleyerek...' },
      { text: 'May I add something?', translation: 'Bir şey ekleyebilir miyim?' },
      { text: 'Let\'s summarize what we have discussed.', translation: 'Tartıştıklarımızı özetleyelim.' },
      { text: 'I agree with that point.', translation: 'O noktaya katılıyorum.' },
      { text: 'In my opinion, we should focus on...', translation: 'Bence ... üzerine odaklanmalıyız.' },
    ]
  },
  '24-5': {
    type: 'roleplay',
    title: 'Assessment Simülasyonu',
    dialogue: [
      { speaker: 'Assessor', text: 'You have 5 minutes. Discuss which quality is most important for cabin crew.', translation: '5 dakikanız var. Kabin ekibi için en önemli niteliğin hangisi olduğunu tartışın.' },
      { speaker: 'Candidate 1', text: 'I believe safety awareness is the most important.', translation: 'Güvenlik bilincinin en önemli olduğuna inanıyorum.' },
      { speaker: 'Candidate 2', text: 'That\'s true, but customer service is also crucial.', translation: 'Doğru, ama müşteri hizmeti de çok önemli.' },
      { speaker: 'Candidate 3', text: 'Perhaps we can say both are equally important?', translation: 'Belki ikisinin de eşit derecede önemli olduğunu söyleyebiliriz?' },
    ]
  },

  // ÜNİTE 25: CV & Cover Letter
  '25-1': {
    type: 'flashcard',
    title: 'CV Yapısı',
    cards: [
      { front: 'CV / Resume', back: 'Özgeçmiş' },
      { front: 'Personal details', back: 'Kişisel bilgiler' },
      { front: 'Education', back: 'Eğitim' },
      { front: 'Work experience', back: 'İş deneyimi' },
      { front: 'Skills', back: 'Beceriler' },
      { front: 'Languages', back: 'Diller' },
      { front: 'Certifications', back: 'Sertifikalar' },
      { front: 'Hobbies and interests', back: 'Hobiler ve ilgi alanları' },
      { front: 'References', back: 'Referanslar' },
    ]
  },
  '25-2': {
    type: 'flashcard',
    title: 'CV Örnekleri',
    cards: [
      { front: 'Proven customer service skills', back: 'Kanıtlanmış müşteri hizmeti becerileri' },
      { front: 'Strong communication abilities', back: 'Güçlü iletişim yetenekleri' },
      { front: 'Excellent team player', back: 'Mükemmel takım oyuncusu' },
      { front: 'Fluent in English and Turkish', back: 'İngilizce ve Türkçe akıcı' },
      { front: 'First Aid certified', back: 'İlk yardım sertifikalı' },
      { front: 'Flexible schedule', back: 'Esnek program' },
      { front: 'Willing to relocate', back: 'Taşınmaya açık' },
    ]
  },
  '25-3': {
    type: 'flashcard',
    title: 'Cover Letter Yazımı',
    cards: [
      { front: 'Cover letter', back: 'Ön yazı / Başvuru mektubu' },
      { front: 'Dear Hiring Manager', back: 'Sayın İşe Alım Yöneticisi' },
      { front: 'I am writing to apply for...', back: '... için başvurmak üzere yazıyorum' },
      { front: 'I am excited about this opportunity', back: 'Bu fırsat için heyecanlıyım' },
      { front: 'I believe I am a strong candidate', back: 'Güçlü bir aday olduğuma inanıyorum' },
      { front: 'Thank you for considering my application', back: 'Başvurumu değerlendirdiğiniz için teşekkürler' },
      { front: 'I look forward to hearing from you', back: 'Sizden haber bekliyorum' },
      { front: 'Sincerely', back: 'Saygılarımla' },
    ]
  },
  '25-4': {
    type: 'flashcard',
    title: 'Anahtar Kelimeler',
    cards: [
      { front: 'Safety-conscious', back: 'Güvenlik bilincine sahip' },
      { front: 'Customer-focused', back: 'Müşteri odaklı' },
      { front: 'Detail-oriented', back: 'Ayrıntılara dikkat eden' },
      { front: 'Multicultural experience', back: 'Çok kültürlü deneyim' },
      { front: 'Problem-solving skills', back: 'Problem çözme becerileri' },
      { front: 'Time management', back: 'Zaman yönetimi' },
      { front: 'Conflict resolution', back: 'Çatışma çözümü' },
      { front: 'Hospitality experience', back: 'Konaklama deneyimi' },
    ]
  },
  '25-5': {
    type: 'quiz',
    title: 'CV Değerlendirme',
    questions: [
      { question: 'CV\'de neler olmalı?', options: ['Sadece ad', 'Kişisel bilgi, eğitim, deneyim, beceriler', 'Sadece fotoğraf', 'Sadece telefon'], correct: 1 },
      { question: '"Cover letter" ne demek?', options: ['Kapak', 'Ön yazı/başvuru mektubu', 'CV', 'Referans'], correct: 1 },
      { question: '"I look forward to hearing from you" ne demek?', options: ['Seni dinledim', 'Sesini duydum', 'Sizden haber bekliyorum', 'Konuşalım'], correct: 2 },
      { question: '"Detail-oriented" ne demek?', options: ['Genel bakmak', 'Ayrıntılara dikkat eden', 'Detay sevmemek', 'Hızlı bakmak'], correct: 1 },
    ]
  },

  // ÜNİTE 26: Final Mock Mülakat
  '26-1': {
    type: 'roleplay',
    title: 'Giriş & Tanışma',
    dialogue: [
      { speaker: 'Interviewer', text: 'Good morning and welcome. Please have a seat. Can I get you some water?', translation: 'Günaydın ve hoş geldiniz. Lütfen oturun. Biraz su alabilir miyim?' },
      { speaker: 'Candidate', text: 'Good morning. Thank you very much. Yes, please, that would be great.', translation: 'Günaydın. Çok teşekkürler. Evet lütfen, harika olur.' },
      { speaker: 'Interviewer', text: 'Let\'s start. Tell me about yourself.', translation: 'Başlayalım. Bize kendinizden bahsedin.' },
      { speaker: 'Candidate', text: 'I am [Name], a 24-year-old tourism graduate from Istanbul. I have 3 years of customer service experience...', translation: 'Ben [Ad], İstanbul\'dan 24 yaşında turizm mezunuyum. 3 yıllık müşteri hizmeti deneyimim var...' },
    ]
  },
  '26-2': {
    type: 'roleplay',
    title: 'Teknik Sorular',
    dialogue: [
      { speaker: 'Interviewer', text: 'What do you know about our airline?', translation: 'Havayolumuz hakkında ne biliyorsunuz?' },
      { speaker: 'Candidate', text: 'Turkish Airlines is one of the largest carriers in the world, flying to over 300 destinations...', translation: 'Türk Hava Yolları 300\'den fazla destinasyona uçan dünyanın en büyük taşıyıcılarından biri...' },
      { speaker: 'Interviewer', text: 'What are the main responsibilities of cabin crew?', translation: 'Kabin ekibinin ana sorumlulukları nelerdir?' },
      { speaker: 'Candidate', text: 'Safety is the primary responsibility, followed by customer service, emergency procedures, and creating a pleasant experience.', translation: 'Güvenlik birincil sorumluluk, sonra müşteri hizmeti, acil prosedürler ve hoş bir deneyim yaratmak.' },
    ]
  },
  '26-3': {
    type: 'roleplay',
    title: 'Senaryo Soruları',
    dialogue: [
      { speaker: 'Interviewer', text: 'A passenger refuses to put their bag in the overhead bin before takeoff. What do you do?', translation: 'Bir yolcu kalkıştan önce çantasını bagaj gözüne koymayı reddediyor. Ne yaparsınız?' },
      { speaker: 'Candidate', text: 'I would politely explain that it is a safety regulation. I would offer to help them store it securely. If they still refuse, I would inform the purser.', translation: 'Kibarca bunun bir güvenlik düzenlemesi olduğunu açıklardım. Güvenli bir şekilde saklamalarına yardımcı olmayı teklif ederdim. Hala reddederlerse, şef kabin memurunu bilgilendirirdim.' },
    ]
  },
  '26-4': {
    type: 'voice',
    title: 'İngilizce Test',
    phrases: [
      { text: 'In my previous role, I learned the importance of patience and clear communication.', translation: 'Önceki görevimde sabır ve açık iletişimin önemini öğrendim.' },
      { text: 'I am confident that my skills and passion make me an excellent fit for this position.', translation: 'Becerilerimin ve tutkumun beni bu pozisyon için mükemmel bir aday yaptığından eminim.' },
      { text: 'Thank you for this opportunity. I am very excited about the possibility of joining your team.', translation: 'Bu fırsat için teşekkürler. Ekibinize katılma olasılığı konusunda çok heyecanlıyım.' },
    ]
  },
  '26-5': {
    type: 'exam',
    title: 'BÖLÜM 3 FİNAL',
    description: 'Mülakat Hazırlık bölümünün final sınavı. Tüm konulardan kapsamlı değerlendirme.',
    totalQuestions: 25,
    passingScore: 80
  }
};

export default INTERVIEW_CONTENTS;
